import React from "react";

const Error = () => {
  return <div>Error 404 not found</div>;
};

export default Error;
